import { Box, Typography } from '@mui/material';

export default function HeightTimeLegend() {
  const items = [
    { label: 'Buzzer Start', color: '#fff' },
    { label: 'First Shot', color: '#F05E7C' },
    { label: 'Presentation Start', color: '#80D4DF' },
    { label: 'Presentation End', color: '#988AE4' },
   // { label: 'Time Slack', color: '#FFD700' },
  ];

  return (
    <Box
      sx={{
        backgroundColor: 'rgba(255,255,255,0.02)',
        border: '1px solid rgba(255,255,255,0.1)',
        borderRadius: 1,
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      }}
    >
      {items.map(({ label, color }) => (
        <Box key={label} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box sx={{ width: 16, height: 16, backgroundColor: color, borderRadius: '2px' }} />
          <Typography variant="body2" color="white">
            {label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
